import React from "react";
import paymentStatusLogo from "../../assets/images/Payment successful.png";
import { ReactComponent as QParkLogo } from "../../assets/images/Q-Park - Quality in parking.svg";
import { FormattedMessage } from "react-intl";

const PaymentSuccessful: React.FC = () => {
  return (
    <React.Fragment>
      <div className="main">
        <div className="content">
          <img src={paymentStatusLogo} alt="Payment successful" className="status-successful" />
          <p className="App-status">
            <FormattedMessage id="successStatus" />
          </p>
          <p className="App-status-info">
            <FormattedMessage id="successStatusInfo" />
          </p>
        </div>
      </div>
      <div className="footer">
        <QParkLogo />
      </div>
    </React.Fragment>
  );
};

export default PaymentSuccessful;
